// extracted by mini-css-extract-plugin
export default {"deactive":"_1Z4I","heading":"_2HtJ"};